import { createRouter, createWebHistory } from "vue-router";
import TrackingView from "@/views/TrackingView.vue";
// import SettingsView from "@/views/SettingsView.vue";
// import HistoryView from "@/views/HistoryView.vue";
// import StatisticsView from "@/views/StatisticsView.vue";
import { useAuthStore } from "@/stores";

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes: [
    {
      path: "/",
      redirect: "/tracking",
    },
    {
      path: "/tracking",
      name: "TrackingView",
      component: async () => TrackingView,
    },
    {
      path: "/household",
      name: "HouseholdView",
      component: async () => import("@/views/HouseholdView.vue"),
    },
    {
      path: "/history",
      name: "HistoryView",
      component: async () => import("@/views/HistoryView.vue"),
    },
    {
      path: "/settings",
      name: "SettingsView",
      component: async () => import("@/views/SettingsView.vue"),
      redirect: "/settings/personal",
      children: [
        {
          path: "personal",
          name: "PersonalSettings",
          component: async () =>
            import("@/components/settings/PersonalSettingsSection.vue"),
        },
        {
          path: "household",
          name: "HouseholdSettings",
          component: async () =>
            import("@/components/settings/HouseholdSettingsSection.vue"),
        },
        {
          path: "chores",
          name: "ChoreSettings",
          component: async () =>
            import("@/components/settings/ChoreSettingsSection.vue"),
        },
        {
          path: "prizes",
          name: "PrizeSettings",
          component: async () =>
            import("@/components/settings/PrizeSettingsSection.vue"),
        },
      ],
    },
    {
      path: "/prizes",
      name: "PrizesView",
      component: async () => import("@/views/PrizesView.vue"),
    },
    {
      path: "/faq",
      name: "FaqView",
      component: async () => import("@/views/FaqView.vue"),
    },
    {
      path: "/registration",
      name: "RegistrationView",
      component: async () => import("@/views/RegisterView.vue"),
    },
    {
      path: "/callback",
      name: "AuthCallback",
      component: { template: "<div>Processing login...</div>" },
    },
    {
      // vue-router 4 catch-all; "/.*" only matched that literal path
      path: "/:pathMatch(.*)*",
      redirect: "/tracking",
    },
  ],
});

router.beforeEach(async (to) => {
  const authStore = useAuthStore();

  // Skip auth checks for callback route - it's handled in main.ts init
  if (to.name === "AuthCallback") {
    return true;
  }

  // Wait for auth initialization
  if (!authStore.isInitialized) {
    await authStore.init();
  }

  // Redirect to registration if not completed
  if (authStore.isUnknownUser && to.name !== "RegistrationView") {
    return { name: "RegistrationView" };
  }

  // Prevent accessing registration if already completed
  if (!authStore.isUnknownUser && to.name === "RegistrationView") {
    return { name: "TrackingView" };
  }
});

export default router;
